import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMicIconSecondary from './svgs/MicIconSecondary.js';
import SvgMicIcon from './svgs/MicIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var micIcon = (props => useIcon(SvgMicIcon, SvgMicIconSecondary, props));

export { micIcon as default };
